var mobiscroll = mobiscroll || {},
    util = {},
    calendars = {};

export { mobiscroll, util, calendars };
